import { call, put, takeEvery } from 'redux-saga/effects';

import {
  receiveAPIResponseHoldingData,
  requestAPIFailedHoldingData,
} from 'src/redux/api/actions';
import { apiCallAsync } from 'src/redux/api/saga';
import { PDF_MERGE_LIST, REPORT_LIST_DATA_KEY } from 'src/redux/constants';
import { getActionAPISource } from 'src/utils';
import { showNotification } from 'src/utils';
import { GET_PUBLICATION_LIST_REQUEST } from './actions';
import { GetPublicationListRequestAction } from './types';

export function* PublicationStatusApiCallSaga(
  action: GetPublicationListRequestAction,
) {
  try {
    let url = getActionAPISource(PDF_MERGE_LIST);
    url = `${url}?period=${action.payload.period}`;

    const response = yield call(apiCallAsync, url);

    if (response.status >= 200 && response.status < 300) {
      yield put(
        receiveAPIResponseHoldingData(response.data, REPORT_LIST_DATA_KEY),
      );
    } else {
      throw new Error('Publication Status API call has failed');
    }
  } catch (e) {
    yield put(
      requestAPIFailedHoldingData(REPORT_LIST_DATA_KEY, {
        message: e.message,
        data: e.response ? e.response.data : null,
      }),
    );
    showNotification(e.message || 'Error', 'error');
    console.error(e);
  }
}

export default function* getPublicationStatusSaga() {
  yield takeEvery(GET_PUBLICATION_LIST_REQUEST, PublicationStatusApiCallSaga);
}
